const API_GATEWAY_HOST = process.env.VUE_APP_API_GATEWAY_HOST
const ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT
const DEFAULT_ES_BUCKET_SIZE = process.env.VUE_APP_DEFAULT_ES_BUCKET_SIZE
const DEFAULT_ES_BUCKET_PAGE_SIZE = process.env.VUE_APP_DEFAULT_ES_BUCKET_PAGE_SIZE

class ConfigService {
  apiGatewayHost () {
    return API_GATEWAY_HOST
  }

  mantenanceLogoutUrl () {
    return API_GATEWAY_HOST + '/logout/maintenance'
  }

  logoutUrl () {
    return API_GATEWAY_HOST + '/logout'
  }

  environment () {
    return ENVIRONMENT
  }

  reauthorizeSilentlyUrl () {
    return API_GATEWAY_HOST + '/auth0/authorize/renew/silent'
  }

  reauthorizeUrl () {
    return API_GATEWAY_HOST + '/auth0/authorize/renew?state=' + window.location.href
  }

  authorizeUrl () {
    return API_GATEWAY_HOST + '/auth0/authorize'
  }

  defaultEsBucketPageSize () {
    return DEFAULT_ES_BUCKET_PAGE_SIZE
  }

  defaultEsBucketSize () {
    return DEFAULT_ES_BUCKET_SIZE
  }
}

export default new ConfigService()
